import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from '../primitives.js';

/**
 * Mutual-like match record. Stored with `userAId < userBId` to enforce a
 * single row per pair (uniqueness on the normalized tuple).
 */
export const MatchSchema = z.object({
  id: UuidSchema,
  userAId: UuidSchema,
  userBId: UuidSchema,
  chatId: UuidSchema,
  status: z.enum(['active', 'unmatched', 'blocked']),
  createdAt: IsoDateTimeSchema,
  dissolvedAt: IsoDateTimeSchema.nullable(),
});
export type Match = z.infer<typeof MatchSchema>;
